import FormDialog from "../../helpers/FormDialog";
import React from "react";
import {validatePassword} from "../../store/helpers/common_functions";

function ChangePassword({open,setOpen}) {
    const [value, setValue] = React.useState({});
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }

    const passwordRegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    return <div>
       <FormDialog open={open} setOpen={setOpen} url={'/api/profile/change/password'} title={'Change Password'} fields={[
           {
               name:"oldPassword",
               label:"Old Password",
               type:'password',
               value:value['oldPassword'],
               required:true,
               setValue:(v)=>setValue0('oldPassword',v)
           },
           {
               name:"newPassword",
               label:"New Password",
               type:'password',
               required:true,
               value:value['newPassword'],
               validate:(val)=>passwordRegExp.test(val) ? undefined : validatePassword(val),
               setValue:(v)=>setValue0('newPassword',v)
           },
           {
               name:"confirmPassword",
               label:"Confirm New Password",
               type:'password',
               required:true,
               value:value['confirmPassword'],
               setValue:(v)=>setValue0('confirmPassword',v),
               validate:(val)=>val === value['newPassword'] ? undefined : 'Password Confirmation Mismatch',
           },
       ]}/>
    </div>
}

export default ChangePassword;
